export default __webpack_public_path__ + "static/media/logo.978cc399.png";